import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_CMS } from "../cms.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateCmsInput } from "../../../__generated__/globalTypes";
import {
  UpdateCmsMutation,
  UpdateCmsMutationVariables,
} from "../../../__generated__/UpdateCmsMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateCms = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateCmsInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateCmsMutation,
    UpdateCmsMutationVariables
  >(UPDATE_CMS, {
    refetchQueries: ["CmsListQuery", "CmsQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateCms?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateCms?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
